import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$1 = ["children"];
var WrappedTooltip = withStyles(function (theme) {
  return {
    tooltip: {
      color: '#fff',
      backgroundColor: 'rgba(0, 0, 0, 0.87)',
      fontSize: theme.typography.pxToRem(12)
    }
  };
})(Tooltip);

var BaseTooltip = function BaseTooltip(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(WrappedTooltip, _extends({
    interactive: true,
    enterTouchDelay: 0,
    leaveTouchDelay: 5000
  }, rest, {
    arrow: true
  }), children);
};

BaseTooltip.propTypes = {
  children: PropTypes.any
};

var _excluded = ["children", "tooltipProps", "className", "outlinedIcon", "inheritColor"];
var useStyle = makeStyles({
  btn: {
    fontSize: '19px',
    boxSizing: 'content-box',
    opacity: 0.8,
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    height: '1em',
    width: '1em',
    '&:hover': {
      opacity: 1
    },
    '&:focus': {
      opacity: 1
    }
  },
  inheritColor: {
    color: 'inherit'
  },
  icon: {
    height: '1em',
    width: '1em',
    fill: 'currentColor'
  }
});

var Info = function Info(_ref) {
  var _cn;

  var children = _ref.children,
      tooltipProps = _ref.tooltipProps,
      className = _ref.className,
      outlinedIcon = _ref.outlinedIcon,
      inheritColor = _ref.inheritColor,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = useStyle();
  var iconProps = {
    className: classes.icon,
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(BaseTooltip, _extends({}, tooltipProps, {
    title: children
  }), /*#__PURE__*/React.createElement(IconButton, _extends({
    color: "primary"
  }, rest, {
    className: cn(classes.btn, className, (_cn = {}, _cn[classes.inheritColor] = inheritColor, _cn))
  }), outlinedIcon ? /*#__PURE__*/React.createElement("svg", _extends({}, iconProps, {
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0ZM8 14.5C4.40625 14.5 1.5 11.5938 1.5 8C1.5 4.4375 4.40625 1.5 8 1.5C11.5625 1.5 14.5 4.4375 14.5 8C14.5 11.5938 11.5625 14.5 8 14.5ZM9.25 10.5H8.75V7.75C8.75 7.34375 8.40625 7 8 7H7C6.5625 7 6.25 7.34375 6.25 7.75C6.25 8.1875 6.5625 8.5 7 8.5H7.25V10.5H6.75C6.3125 10.5 6 10.8438 6 11.25C6 11.6875 6.3125 12 6.75 12H9.25C9.65625 12 10 11.6875 10 11.25C10 10.8438 9.65625 10.5 9.25 10.5ZM8 6C8.53125 6 9 5.5625 9 5C9 4.46875 8.53125 4 8 4C7.4375 4 7 4.46875 7 5C7 5.5625 7.4375 6 8 6Z"
  })) : /*#__PURE__*/React.createElement("svg", _extends({}, iconProps, {
    viewBox: "0 0 512 512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
  }))));
};

Info.propTypes = {
  inheritColor: PropTypes.bool,
  children: PropTypes.any,
  tooltipProps: PropTypes.object,
  outlinedIcon: PropTypes.bool,
  className: PropTypes.string
};

export { Info, BaseTooltip as Tooltip };
//# sourceMappingURL=index.module.js.map
